<ft-modal-editor-wrapper #wrapperRef [canSave]="canSave" [hasCloseButton]="hasCloseButton">
    <ng-template #triggerTmpl>
        <ng-content></ng-content>
    </ng-template>
    <ng-content select="[content]"></ng-content>
</ft-modal-editor-wrapper>
